// Constants
const STATIC_BRAUZ_MODAL_ID = 'brauz--book-a-fitting'
const BRAUZ_OPEN_FUNCTION = 'Brauz_open_book_a_stylist_dialog'

class BrauzModalHandler {
  constructor() {
    this.observer = null
    this.boundHandleClick = this.handleClick.bind(this)
    this.init()
    this.handleAttempt = 0
    this.handleLimit = 5
  }

  init() {
    if (window.brauzModalHandler !== undefined) return
    this.setupBrauzHandlers()
  }

  setupBrauzHandlers() {
    this.handleUrlHash()
    this.setupExistingLinks()
    this.watchForNewLinks()
  }

  handleClick(e) {
    e.preventDefault()
    window[BRAUZ_OPEN_FUNCTION]()
  }

  isBrauzLink(element) {
    return element?.tagName === 'A' &&
           element?.href?.includes(STATIC_BRAUZ_MODAL_ID)
  }

  setupExistingLinks() {
    const links = document.querySelectorAll(`a[href*="${STATIC_BRAUZ_MODAL_ID}"]`)
    links.forEach(link => {
      link.removeEventListener('click', this.boundHandleClick) // Prevent duplicate listeners
      link.addEventListener('click', this.boundHandleClick)
    })
  }

  watchForNewLinks() {
    // Disconnect existing observer if any
    if (this.observer) {
      this.observer.disconnect()
    }

    this.observer = new MutationObserver((mutations) => {
      const shouldProcessMutation = (mutation) => {
        return mutation.addedNodes.length > 0 &&
               Array.from(mutation.addedNodes).some(node =>
                 node.querySelector?.(`a[href*="${STATIC_BRAUZ_MODAL_ID}"]`) ||
                 this.isBrauzLink(node)
               )
      }

      // Only process mutations that actually add relevant nodes
      if (mutations.some(shouldProcessMutation)) {
        this.setupExistingLinks()
      }
    })

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  }

  handleUrlHash() {
    if (this.handleAttempt >= this.handleLimit) return
    const hash = window.location.hash.slice(1)
    if (hash === STATIC_BRAUZ_MODAL_ID) {
      if (window[BRAUZ_OPEN_FUNCTION] === undefined) {
        // Try again after a delay
        return setTimeout(() => this.handleUrlHash(), 500)
      }
      window[BRAUZ_OPEN_FUNCTION]()
    }
  }

  // Cleanup method for unmounting
  destroy() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    document.querySelectorAll(`a[href*="${STATIC_BRAUZ_MODAL_ID}"]`)
      .forEach(link => {
        link.removeEventListener('click', this.boundHandleClick)
      })
  }
}

window.brauzModalHandler = new BrauzModalHandler()
// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.brauzModalHandler = new BrauzModalHandler()
})
